export default "__VITE_ASSET__BwF8oMTf__"